var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSenseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 11.3132 19.7413 12.6136 19.2388 13.8268C18.7362 15.0401 17.9997 16.1425 17.0711 17.0711C16.1425 17.9997 15.0401 18.7362 13.8268 19.2388C12.6136 19.7413 11.3132 20 10 20L10 16.0889C10.7996 16.0889 11.5914 15.9315 12.3301 15.6255C13.0689 15.3195 13.7401 14.8709 14.3055 14.3055C14.8709 13.7401 15.3195 13.0689 15.6255 12.3301C15.9315 11.5914 16.0889 10.7996 16.0889 10H20Z",
    fill: "#1F6578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.3132 1.566e-08 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10L16.0889 10C16.0889 9.20039 15.9315 8.40861 15.6255 7.66986C15.3195 6.93112 14.8709 6.25988 14.3055 5.69446C13.7401 5.12905 13.0689 4.68054 12.3301 4.37455C11.5914 4.06855 10.7996 3.91105 10 3.91105L10 0Z",
    fill: "#F8D16F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C2.3186e-07 7.34783 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 -3.16267e-08 10 0L10 3.91105C8.38511 3.91105 6.83636 4.55256 5.69446 5.69446C4.55256 6.83636 3.91105 8.38511 3.91105 10L0 10Z",
    fill: "#DF4959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.68678 20 7.38642 19.7413 6.17317 19.2388C4.95991 18.7362 3.85752 17.9997 2.92893 17.0711C2.00035 16.1425 1.26375 15.0401 0.761204 13.8268C0.258657 12.6136 -1.14805e-07 11.3132 0 10L3.91105 10C3.91105 10.7996 4.06855 11.5914 4.37455 12.3301C4.68054 13.0689 5.12905 13.7401 5.69446 14.3055C6.25987 14.8709 6.93112 15.3195 7.66986 15.6255C8.40861 15.9315 9.20039 16.0889 10 16.0889L10 20Z",
    fill: "#8B358B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenseIcon);
export default __webpack_public_path__ + "static/media/sense-icon.76e80ef178542aabea8a4b8a72a79ad3.svg";
export { ForwardRef as ReactComponent };